// extracted by mini-css-extract-plugin
export var editInput = "_e4-0";
export var editInputCompact = "_e4-2";
export var editInputLarge = "_e4-1";
export var editInputSmall = "_e4-3";